// extracted by mini-css-extract-plugin
export default {"root":"PreCheckStarted_root__bb2Vw","btn":"PreCheckStarted_btn__WNRoR"};